var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "SBbetSlip",
      class: [
        _vm.betSlipState[_vm.currentBetSlipState],
        { hasErrors: _vm.showError },
        _vm.errorId
      ]
    },
    [
      _c("div", { staticClass: "betslipHeader" }, [
        false
          ? _c("div", [
              _c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.title")))]),
              _vm._v(" "),
              _c("span", [_vm._v(": " + _vm._s(_vm.betsNo))]),
              _vm._v(
                "\n      | State: " +
                  _vm._s(_vm.currentBetSlipState) +
                  " |\n      | StateName: " +
                  _vm._s(_vm.betSlipState[_vm.currentBetSlipState]) +
                  " |\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tabs is-boxed is-centered is-fullwidth is-toggle" },
          [
            false
              ? _c(
                  "span",
                  {
                    staticClass: "tab",
                    class: { active: _vm.tab === "S", disabled: true }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "a-link-",
                        class: { disabled: _vm.betsNo === 0 },
                        on: {
                          click: function($event) {
                            return _vm.setTab("S")
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.S")))])]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "tab",
                class: { active: _vm.tab === "REGULAR", disabled: true }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "a-link-",
                    class: { disabled: _vm.betsNo === 0 },
                    on: {
                      click: function($event) {
                        return _vm.setTab("REGULAR")
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.REGULAR")))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "tab", class: { active: _vm.tab === "TEASER" } },
              [
                _c(
                  "a",
                  {
                    staticClass: "a-link",
                    class: { disabled: _vm.betsNo <= 1 },
                    on: {
                      click: function($event) {
                        return _vm.setTab("TEASER")
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.TEASER")))])]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "tab", class: { active: _vm.tab === "RR" } },
              [
                _c(
                  "a",
                  {
                    staticClass: "a-link",
                    class: { disabled: _vm.betsNo <= 2 },
                    on: {
                      click: function($event) {
                        return _vm.setTab("RR")
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.RR")))])]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.betsNo
        ? _c("div", { staticClass: "add-bets-container" }, [
            _c("span", { staticClass: "pd-icon pd-icon-plus-sign" }),
            _vm._v(" "),
            _c("div", { staticClass: "ab-info-msg" }, [
              _c("span", { staticClass: "ab-label" }, [
                _vm._v(_vm._s(_vm.$t("BetSlip.add.bets")))
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "ab-label",
                domProps: { innerHTML: _vm._s(_vm.$t("BetSlip.zero.bets")) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { clear: "both" } }),
      _vm._v(" "),
      !_vm.gettingABTnR
        ? _c("input", {
            attrs: { type: "hidden" },
            domProps: { value: _vm.calculateWin() }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.betsNo
        ? _c("div", { staticClass: "empty-betslip", class: _vm.tab }, [
            _c("div", { staticClass: "msg", class: _vm.tab })
          ])
        : _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !(
                      _vm.currentBetSlipState == 5 &&
                      _vm.betSlipStatus.State == 2
                    ),
                    expression:
                      "!(currentBetSlipState==5 && betSlipStatus.State==2)"
                  }
                ],
                staticClass: "bets"
              },
              [
                _vm.tab === "REGULAR"
                  ? _c("div", { class: _vm.tab }, [
                      _vm.betsNo >= 2
                        ? _c(
                            "div",
                            [
                              _c("parlay", {
                                attrs: {
                                  betsNo: _vm.betsNo,
                                  allowedBetTypesAndReturns:
                                    _vm.allowedBetTypesAndReturns.REGULAR,
                                  allowedBetTypesPRL: _vm.allowedBetTypesPRL,
                                  currentBetSlipState: _vm.currentBetSlipState,
                                  gettingABTnR: _vm.gettingABTnR,
                                  betTypeStakes:
                                    _vm.betTypeStakes.REGULAR.PerBetType,
                                  winnings: _vm.winnings.REGULAR.PerBetType
                                },
                                on: {
                                  initPlaceBet: function($event) {
                                    return _vm.initPlaceBet()
                                  },
                                  placeBet: function($event) {
                                    return _vm.placeBet()
                                  },
                                  cancelBet: function($event) {
                                    return _vm.cancelBet()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === "REGULAR" || _vm.tab === "RR"
                  ? _c(
                      "div",
                      { staticClass: "singles", class: _vm.tab },
                      [
                        _vm.tab === "REGULAR" && _vm.currentBetSlipState < 1
                          ? _c(
                              "div",
                              {
                                staticClass: "header-SING",
                                class: {
                                  focused: _vm.focus[0],
                                  "non-empty": !!_vm.multiSinglesStake
                                }
                              },
                              [
                                _c("h2", { staticClass: "betslip-tab-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.title.SINGLE" +
                                          (_vm.betsNo > 1 ? "S" : "")
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.betsNo > 1 &&
                                          _vm.currentBetSlipState < 1,
                                        expression:
                                          "betsNo>1 && currentBetSlipState<1"
                                      }
                                    ],
                                    staticClass: "stakeAll"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "multiSinglesStake" },
                                      [
                                        _c("money-input", {
                                          attrs: {
                                            id: 1,
                                            placeholder: _vm.$t(
                                              "BetSlip.single.stakeAll"
                                            ),
                                            disabled:
                                              _vm.currentBetSlipState >= 1,
                                            focus: _vm.focus,
                                            className: "input-only"
                                          },
                                          on: {
                                            setFocus: _vm.setFocus,
                                            dismissError: function($event) {
                                              return _vm.dismissBetSlip(
                                                null,
                                                true
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.multiSinglesStake,
                                            callback: function($$v) {
                                              _vm.multiSinglesStake = $$v
                                            },
                                            expression: "multiSinglesStake"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.betslipSelectionIds, function(selectionId) {
                          return _c("bet-slip-selection", {
                            key: selectionId,
                            attrs: {
                              isFor: "REGULAR",
                              selectionId: selectionId,
                              tab: _vm.tab,
                              betTypeStakes:
                                _vm.betTypeStakes.REGULAR.PerSelection,
                              betTypeStakesPerBetType:
                                _vm.betTypeStakes.REGULAR.PerBetType,
                              allowedBetTypesAndReturns:
                                _vm.allowedBetTypesAndReturns.REGULAR,
                              winnings: _vm.winnings.REGULAR.PerSelection,
                              multiSingles: _vm.multiSingles,
                              multiSinglesStake: _vm.multiSinglesStake,
                              currentBetSlipState: _vm.currentBetSlipState,
                              isLive: _vm.checkLive(selectionId)
                            },
                            on: {
                              removeSelection: _vm.removeSelection,
                              updateSelected: _vm.updateSelected
                            }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === "TEASER"
                  ? _c(
                      "div",
                      { class: _vm.tab },
                      [
                        _c("teaser", {
                          attrs: {
                            tab: _vm.tab,
                            betsNo: _vm.betsNo,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns,
                            allowedBetTypesPRL: _vm.allowedBetTypesPRL,
                            allowedBetTypesRR: _vm.allowedBetTypesRR,
                            currentBetSlipState: _vm.currentBetSlipState,
                            gettingABTnR: _vm.gettingABTnR,
                            betTypeStakes: _vm.betTypeStakes.TEASER,
                            winnings: _vm.winnings.TEASER
                          },
                          on: {
                            initPlaceBet: function($event) {
                              return _vm.initPlaceBet()
                            },
                            placeBet: function($event) {
                              return _vm.placeBet()
                            },
                            cancelBet: function($event) {
                              return _vm.cancelBet()
                            },
                            setTeaserType: _vm.setTeaserType,
                            updateSelected: _vm.updateSelected
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.tab === "RR"
                  ? _c(
                      "div",
                      { class: _vm.tab },
                      [
                        _c("round-robin", {
                          attrs: {
                            betsNo: _vm.betsNo,
                            betslipSelections: _vm.betslipSelectionIds,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns.RR,
                            allowedBetTypesRR: _vm.allowedBetTypesRR,
                            allowedBetTypesPRL: _vm.allowedBetTypesPRLRR,
                            activeRR: _vm.activeRR,
                            currentBetSlipState: _vm.currentBetSlipState,
                            gettingABTnR: _vm.gettingABTnR,
                            betTypeStakes: _vm.betTypeStakes.RR.PerBetType,
                            winnings: _vm.winnings.RR.PerBetType
                          },
                          on: {
                            initPlaceBet: function($event) {
                              return _vm.initPlaceBet()
                            },
                            placeBet: function($event) {
                              return _vm.placeBet()
                            },
                            cancelBet: function($event) {
                              return _vm.cancelBet()
                            },
                            calculateWin: _vm.calculateWin,
                            updateSelected: _vm.updateSelected
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "fixed_footer_sep",
        class: { bet_placed: _vm.betSlipStatus.State == 2 },
        style: _vm.betslipActionsHeight
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "betActions",
          staticClass: "betslip_actions",
          class: { bet_placed: _vm.betSlipStatus.State == 2 }
        },
        [
          _vm.betsNo
            ? _c("div", { staticClass: "action-msg" }, [
                _vm.currentBetSlipState > 1
                  ? _c(
                      "div",
                      {
                        staticClass: "betPlacement",
                        class: { bet_placed: _vm.betSlipStatus.State == 2 }
                      },
                      [
                        _vm.currentBetSlipState == 2
                          ? _c("div", { staticClass: "align-center" }, [
                              _c("div", { staticClass: "loading" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("BetSlip.status.placing-in"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _c("circle-loader-with-counter", {
                                      attrs: { n: _vm.inRunningDelay }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentBetSlipState == 3
                          ? _c("div", { staticClass: "align-center" }, [
                              _vm.inRefferal
                                ? _c("h3", [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "BetSlip.status.acceptable.referred.reOffered"
                                          )
                                        )
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.inRefferal
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "msg",
                                      class: { inRefferal: _vm.inRefferal }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.betPlacementStatus.Status.detailed.referred.reOffered"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "loading" },
                                [_c("circle-loader")],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentBetSlipState == 4
                          ? _c("div", { staticClass: "align-center" }, [
                              _c(
                                "div",
                                { staticClass: "loading" },
                                [_c("dots-loader")],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentBetSlipState == 5
                          ? _c("div", { staticClass: "align-center" }, [
                              _vm.betSlipStatus.State == 2
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "bet_placed_img",
                                      attrs: {
                                        src: require("@/assets/images/betslip/CheckMark.svg"),
                                        alt: "Betslip"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("h3", [
                                      _vm.numberOfSucessfulyPlacedBets == 1
                                        ? _c("span", { key: "betplacedsing" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("BetSlip.status.placed")
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.numberOfSucessfulyPlacedBets > 1
                                        ? _c("span", { key: "betplacedpl" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.status.placed.pl",
                                                  {
                                                    n:
                                                      _vm.numberOfSucessfulyPlacedBets
                                                  }
                                                )
                                              )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.numberOfSucessfulyPlacedBets <
                                      _vm.betPlacementResult.result.Bets.length
                                        ? _c("span", [
                                            _c("br"),
                                            _vm._v(" "),
                                            _vm.betPlacementResult.result.Bets
                                              .length -
                                              _vm.numberOfSucessfulyPlacedBets ==
                                            1
                                              ? _c(
                                                  "span",
                                                  { key: "betfailedsing" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BetSlip.status.placed.failed"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  { key: "betfailedpl" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BetSlip.status.placed.failed.pl",
                                                          {
                                                            n:
                                                              _vm
                                                                .betPlacementResult
                                                                .result.Bets
                                                                .length -
                                                              _vm.numberOfSucessfulyPlacedBets
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "goodLuck_text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.status.placed.GoodLuck"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.betSlipStatus.State == 4
                                ? _c("div", [
                                    _c("h3", [
                                      !_vm.errorType
                                        ? _c("span", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.rejected"
                                                  )
                                                ) +
                                                "\n            "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.placement.error." +
                                                      _vm.errorType +
                                                      "." +
                                                      "result"
                                                  )
                                                ) +
                                                "\n               "
                                            )
                                          ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.betPlacementResult.result.Status
                                      .StatusText
                                      ? _c(
                                          "div",
                                          { staticClass: "reject-reason" },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.betPlacementResult.result
                                                    .Status.StatusText
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.betSlipStatus.State == 5
                                ? _c(
                                    "div",
                                    [
                                      _c("h3", [
                                        _vm.inRefferal
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.waiting.reffer"
                                                  )
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.waiting"
                                                  )
                                                )
                                              )
                                            ])
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.betPlacementResult.result.Status
                                          .detailedStates,
                                        function(reason) {
                                          return _c("div", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.betPlacementStatus.Status.detailed." +
                                                      reason
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            reason === "reOffered"
                                              ? _c("span", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "$ " +
                                                        _vm._s(
                                                          _vm.betPlacementResult.result.TotalStake.toFixed(
                                                            2
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ])
                                              : _vm._e()
                                          ])
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "loading" },
                                        [_c("circle-loader")],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentBetSlipState == 6
                          ? _c(
                              "div",
                              { staticClass: "align-center" },
                              [
                                _vm.betSlipStatus.State == 1
                                  ? _c(
                                      "h3",
                                      { staticClass: "Bet-Acceptable" },
                                      [
                                        _vm.betPlacementResult.result.Status
                                          .detailedStates &&
                                        _vm.betPlacementResult.result.Status.detailedStates.indexOf(
                                          "reOffered"
                                        ) > -1
                                          ? _c("span", [
                                              _vm.inRefferal
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "BetSlip.status.acceptable.referred.reOffered"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BetSlip.status.acceptable.reOffered"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ])
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.acceptable"
                                                  )
                                                )
                                              )
                                            ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.betSlipStatus.State == 3
                                  ? _c("h3", { staticClass: "Bet-Reoffered" }, [
                                      _vm.betPlacementResult.result.Status
                                        .detailedStates &&
                                      _vm.betPlacementResult.result.Status.detailedStates.indexOf(
                                        "reOffered"
                                      ) > -1
                                        ? _c("span", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.status.reoffered.reOffered"
                                                  )
                                                )
                                              )
                                            ])
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.status.acceptable"
                                                )
                                              )
                                            )
                                          ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "msg bet_actions_msg",
                                    class: { inRefferal: _vm.inRefferal }
                                  },
                                  _vm._l(
                                    _vm.betPlacementResult.result.Status
                                      .detailedStates,
                                    function(reason) {
                                      return _c("div", [
                                        _vm.inRefferal && reason == "reOffered"
                                          ? _c("span", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.betPlacementStatus.Status.detailed.referred." +
                                                        reason
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.betPlacementStatus.Status.detailed.referred.reOffered.scroll"
                                                      )
                                                    )
                                                )
                                              ])
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "BetSlip.betPlacementStatus.Status.detailed." +
                                                      reason
                                                  )
                                                )
                                              )
                                            ])
                                      ])
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                !_vm.inRefferal
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("BetSlip.status.confirmIn")
                                        ) +
                                          " " +
                                          _vm._s(_vm.gracePeriod)
                                      )
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.gracePeriod,
                                            expression: "gracePeriod"
                                          }
                                        ]
                                      },
                                      [
                                        _c("circle-loader-with-counter", {
                                          attrs: { n: _vm.gracePeriod }
                                        })
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.betPlacementResult.result.Status
                                    .detailedStates,
                                  function(reason) {
                                    return !_vm.inRefferal
                                      ? _c("div", [
                                          reason == "reOffered"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.betPlacementStatus.Status.detailed.reOffered.call"
                                                    )
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      : _vm._e()
                                  }
                                )
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentBetSlipState == 7
                          ? _c("div", { staticClass: "align-center" }, [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("BetSlip.status.canceled"))
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentBetSlipState == 8
                          ? _c("div", { staticClass: "align-center" }, [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("BetSlip.status.timedOut"))
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.currentBetSlipState == 5 ||
                          _vm.currentBetSlipState == 6) &&
                        _vm.betPlacementResult.result &&
                        _vm.betSlipStatus.State == 2
                          ? _c(
                              "div",
                              {
                                class: _vm.tab,
                                attrs: { id: "betSlipReceipt" }
                              },
                              [
                                _vm.betSlipStatus.State == 2
                                  ? _c("div", { staticClass: "totals" }, [
                                      _vm.betPlacementResult.result
                                        .ExternalReference
                                        ? _c(
                                            "div",
                                            { staticClass: "reference" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BetSlip.receipt.reference"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.betPlacementResult
                                                        .result
                                                        .ExternalReference
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "wagered" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("BetSlip.receipt.wagered")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            " $ " +
                                              _vm._s(
                                                _vm.betPlacementResult.result.TotalStake.toFixed(
                                                  2
                                                )
                                              )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "potential-return" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.receipt.winning.potential"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              " $ " +
                                                _vm._s(
                                                  _vm.attemptedBetPotentialReturn
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showReceiptDetails
                                  ? _c(
                                      "div",
                                      { staticClass: "receipt-details" },
                                      _vm._l(
                                        _vm.betPlacementResult.result.Bets,
                                        function(bet) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass: "Bet",
                                              staticStyle: { padding: "5px 0" }
                                            },
                                            [
                                              _c("div", [
                                                bet.IDFOBetType != "S"
                                                  ? _c("div", [
                                                      _c("strong", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "BetSlip.receipt." +
                                                                  _vm.tab +
                                                                  ".betType." +
                                                                  bet.IDFOBetType,
                                                                {
                                                                  n:
                                                                    bet.BetLegs
                                                                      .length
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("strong", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BetSlip.receipt." +
                                                              _vm.tab +
                                                              "." +
                                                              bet.IDFOBetType,
                                                            {
                                                              n:
                                                                bet.BetLegs
                                                                  .length
                                                            }
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BetSlip.receipt.reference"
                                                      )
                                                    ) +
                                                      ": " +
                                                      _vm._s(
                                                        _vm.betTypeRef(bet)
                                                      )
                                                  ),
                                                  _c("br")
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              bet.IDFOBetType == "S"
                                                ? _c(
                                                    "div",
                                                    _vm._l(
                                                      bet.BetLegs,
                                                      function(leg) {
                                                        return _c(
                                                          "div",
                                                          _vm._l(
                                                            _vm.getSelectionDataById(
                                                              leg.IDFOSelection
                                                            ),
                                                            function(
                                                              legSelection
                                                            ) {
                                                              return _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "selection-data",
                                                                    staticStyle: {
                                                                      "padding-left":
                                                                        "10px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "event-name"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            legSelection
                                                                              .market
                                                                              .eventname
                                                                          ) +
                                                                            "\n                      "
                                                                        ),
                                                                        legSelection
                                                                          .market
                                                                          .tsstart
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "selection-ts"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "time"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "moment"
                                                                                        )(
                                                                                          legSelection
                                                                                            .market
                                                                                            .tsstart,
                                                                                          _vm
                                                                                            .dateFormats
                                                                                            .longTime
                                                                                        )
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "date"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "moment"
                                                                                        )(
                                                                                          legSelection
                                                                                            .market
                                                                                            .tsstart,
                                                                                          _vm
                                                                                            .dateFormats
                                                                                            .shortDate
                                                                                        )
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "selection-name"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "name"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                          " +
                                                                                    _vm._s(
                                                                                      _vm.formatSelectionName(
                                                                                        legSelection.selection
                                                                                      )
                                                                                    ) +
                                                                                    "\n                         "
                                                                                ),
                                                                                legSelection
                                                                                  .selection
                                                                                  .currenthandicap
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "currenthandicap"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.formatHandicap(
                                                                                              legSelection.selection
                                                                                            )
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "market-name"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            legSelection
                                                                              .market
                                                                              .name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.betPlacementResult.result.Bets
                                                .length >= 1
                                                ? _c("div", [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BetSlip.receipt.stake.total"
                                                          )
                                                        ) +
                                                          ": $ " +
                                                          _vm._s(
                                                            bet.TotalStake.toFixed(
                                                              2
                                                            )
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    bet.IDFOBetType == "S"
                                                      ? _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "BetSlip.receipt.odds"
                                                              )
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.formatOddsFromReturn(
                                                                  bet
                                                                )
                                                              )
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BetSlip.receipt.return.potential"
                                                          )
                                                        ) +
                                                          ": $ " +
                                                          _vm._s(
                                                            (
                                                              bet.PotentialReturn -
                                                              bet.TotalStake
                                                            ).toFixed(2)
                                                          )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.betsNo || _vm.isLoggedIn,
                  expression: "betsNo || isLoggedIn"
                }
              ],
              staticClass: "action-btns",
              class: [
                _vm.betSlipState[_vm.currentBetSlipState],
                { inRefferal: _vm.inRefferal }
              ]
            },
            [
              _vm.currentBetSlipState == 9 || _vm.showError
                ? _c("div", { staticClass: "align-center" }, [
                    _vm.errorMsg
                      ? _c(
                          "div",
                          { staticClass: "errorMsg", class: _vm.errorId },
                          [
                            _c("icon", {
                              attrs: {
                                name: "icon-information",
                                colorName: "white"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "message",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "BetSlip.placement.error." + _vm.errorId,
                                    {
                                      uiView: this.isOpenedFromWebView
                                        ? "?uiView=true"
                                        : "",
                                      MAX_TAKEOUT: this.maxTakeOut,
                                      SLIP_TOTALSTAKE_MIN: this
                                        .slipTotalStakeMin,
                                      SLIP_TOTALSTAKE_MAX: this
                                        .slipTotalStakeMax,
                                      SLIP_TOTALSTAKE_MAX_INPLAY: this
                                        .slipTotalStakeMaxInPlay
                                    }
                                  )
                                )
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "errorMsg" },
                          [
                            _c("icon", {
                              attrs: {
                                name: "icon-information",
                                colorName: "white"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "message" }, [
                              _vm._v(_vm._s(_vm.$t("BetSlip.status.error")))
                            ])
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _vm.errors.OTHER
                      ? _c(
                          "div",
                          { staticClass: "errorMsg" },
                          [
                            _c("icon", {
                              attrs: {
                                name: "icon-information",
                                colorName: "white"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "message" }, [
                              _vm._v(_vm._s(_vm.errors.OTHER))
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentBetSlipState == 0 && _vm.betsNo,
                      expression: "currentBetSlipState==0 && betsNo"
                    }
                  ],
                  staticClass: "align-center btn-container"
                },
                [
                  _c("div", { staticClass: "column column-right" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isLoggedIn,
                            expression: "!isLoggedIn"
                          }
                        ]
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn primary-button primary-btn",
                            on: {
                              click: function($event) {
                                return _vm.popLogIn()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("BetSlip.btn.msg.LogIn")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoggedIn,
                            expression: "isLoggedIn"
                          }
                        ]
                      },
                      [
                        _c("div", { staticClass: "betslip_total_cost" }, [
                          _c("div", [
                            _c("div", { staticClass: "line1" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("BetSlip.btn.PlaceBet.TotalCost")
                                  )
                                )
                              ]),
                              _vm._v(
                                ":  $" +
                                  _vm._s(this.betTypeStakes.PerTab[_vm.tab]) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "line2" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BetSlip.btn.PlaceBet.TotalPotentialReturn"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(
                                ":  $" +
                                  _vm._s(this.winnings.PerTab[_vm.tab]) +
                                  "\n                "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.showBetSlipChanged
                          ? _c(
                              "button",
                              {
                                staticClass: "btn acceptChanges",
                                on: {
                                  click: function($event) {
                                    return _vm.acceptChanges()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("BetSlip.changed.btn.accept")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn primary-button primary-btn",
                                class: _vm.disablePlaceBet(),
                                attrs: { disabled: _vm.disablePlaceBet() },
                                on: {
                                  click: function($event) {
                                    return _vm.initPlaceBet()
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "btn-label" }, [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.gettingABTnR,
                                          expression: "gettingABTnR"
                                        }
                                      ],
                                      staticClass: "loader-container"
                                    },
                                    [_c("circle-loader")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("BetSlip.btn.PlaceBet"))
                                    )
                                  ])
                                ])
                              ]
                            )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              !_vm.isOpenedFromWebView && !_vm.mobileBigAndBelow
                ? _c("div", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isGeolocated && _vm.isLoggedIn,
                            expression: "!isGeolocated && isLoggedIn"
                          }
                        ],
                        staticClass: "not-geolocated"
                      },
                      [
                        _vm.geolocationMessage.errorCode === "verify"
                          ? _c(
                              "div",
                              {
                                key:
                                  _vm.geolocationMessage.errorCode +
                                  "-" +
                                  Math.random()
                              },
                              [
                                _c("p", { staticClass: "pls-wait" }, [
                                  _vm._v(_vm._s(_vm.$t("BetSlip.pleaseWait")))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "verify" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("BetSlip.VerifyingLocation"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "loader-container" },
                                  [_c("circle-loader")],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.geolocationMessage.errorCode === 999 ||
                        _vm.geolocationMessage.errorCode === 612 ||
                        (_vm.errorMsgLocalStorage === "999" ||
                          _vm.errorMsgLocalStorage === "612")
                          ? _c(
                              "div",
                              {
                                key:
                                  _vm.geolocationMessage.errorCode +
                                  "-" +
                                  Math.random()
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BetSlip.notLocated." + _vm.state)
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.isHardGeolocation
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.tryAgain." + _vm.state
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentBetSlipState == 1 && _vm.betsNo,
                      expression: "currentBetSlipState==1 && betsNo"
                    }
                  ],
                  staticClass: "align-center btn-container"
                },
                [
                  _c("div", { staticClass: "column column-left" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        on: {
                          click: function($event) {
                            return _vm.cancelBet()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("BetSlip.placement.btn.EDIT")))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column column-right" }, [
                    _vm.showBetSlipChanged && !_vm.showError
                      ? _c(
                          "button",
                          {
                            staticClass: "btn acceptChanges",
                            on: {
                              click: function($event) {
                                return _vm.acceptChanges()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("BetSlip.changed.btn.accept")) +
                                "\n          "
                            )
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn secondary",
                            class: _vm.disablePlaceBet(),
                            attrs: { disabled: _vm.disablePlaceBet() },
                            on: {
                              click: function($event) {
                                return _vm.placeBet()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _c("div", { staticClass: "line1" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BetSlip.placement.btn.CONFIRM")
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentBetSlipState > 1,
                      expression: "currentBetSlipState>1"
                    }
                  ],
                  staticClass: "betPlacement"
                },
                [
                  _vm.currentBetSlipState == 5
                    ? _c("div", { staticClass: "align-center" }, [
                        _vm.betSlipStatus.State == 2
                          ? _c("div", { staticClass: "action_buttons" }, [
                              _c("div", { staticClass: "column column-left" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn secondary",
                                    on: {
                                      click: function($event) {
                                        return _vm.dismissBetSlip()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.placement.btn.DISMISS"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "column column-right" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn primary",
                                      on: {
                                        click: function($event) {
                                          return _vm.dismissBetSlip(true)
                                        }
                                      }
                                    },
                                    [
                                      _vm.betsNo == 1
                                        ? _c("span", { key: _vm.betsNo }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.placement.btn.KEEP"
                                                )
                                              )
                                            )
                                          ])
                                        : _c("span", { key: _vm.betsNo }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlip.placement.btn.KEEP.pl"
                                                )
                                              )
                                            )
                                          ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.betSlipStatus.State == 4
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn bet_rejected",
                                  on: {
                                    click: function($event) {
                                      return _vm.dismissBetSlip()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("BetSlip.placement.btn.OK")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.betSlipStatus.State == 5 &&
                        _vm.betPlacementResult.result.Status.detailedStates &&
                        _vm.betPlacementResult.result.Status.detailedStates.indexOf(
                          "referred"
                        ) == -1
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn_blue",
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectBetSlip()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("BetSlip.placement.btn.CANCEL")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 6
                    ? _c(
                        "div",
                        { staticClass: "align-center action_buttons" },
                        [
                          _vm.inRefferal
                            ? _c("div", { staticClass: "column column-left" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn_white",
                                    on: {
                                      click: function($event) {
                                        return _vm.rejectBetSlip()
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", {
                                      attrs: { name: "icon-close-red" }
                                    }),
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "BetSlip.placement.btn.CANCEL.reffer"
                                        )
                                      ) + " "
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.inRefferal
                            ? _c(
                                "div",
                                { staticClass: "column column-right" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn_green",
                                      class: { inRefferal: _vm.inRefferal },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmBetSlip()
                                        }
                                      }
                                    },
                                    [
                                      _c("icon", {
                                        attrs: {
                                          name: "icon-tick",
                                          colorName: "white"
                                        }
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.placement.btn.CONFIRM.reffer"
                                          )
                                        ) + " "
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.inRefferal
                            ? _c("div", { staticClass: "column column-left" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn_white",
                                    on: {
                                      click: function($event) {
                                        return _vm.confirmBetSlip()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "BetSlip.placement.btn.CONFIRM"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.inRefferal
                            ? _c(
                                "div",
                                { staticClass: "column column-right" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn_blue",
                                      on: {
                                        click: function($event) {
                                          return _vm.rejectBetSlip()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "BetSlip.placement.btn.CANCEL"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 7
                    ? _c("div", { staticClass: "align-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn secondary btn_blue",
                            on: {
                              click: function($event) {
                                return _vm.dismissBetSlip(0, 0, 1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("BetSlip.placement.btn.OK")) +
                                " "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 8
                    ? _c("div", { staticClass: "align-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn secondary btn_blue",
                            on: {
                              click: function($event) {
                                return _vm.dismissBetSlip(0, 0, 1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("BetSlip.placement.btn.OK")) +
                                "  "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentBetSlipState == 9
                    ? _c("div", { staticClass: "align-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn secondary btn_blue",
                            on: {
                              click: function($event) {
                                return _vm.dismissBetSlip(0, 0, 1)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("BetSlip.placement.btn.OK")) +
                                "  "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              !_vm.mobileBigAndBelow
                ? _c("div", { staticStyle: { height: "10px" } })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentBetSlipState == 0 && _vm.betsNo
                ? _c(
                    "div",
                    { staticClass: "betslip_footer_bottom" },
                    [
                      _c(
                        "v-btn",
                        { staticClass: "delALL", on: { click: _vm.clearAll } },
                        [
                          _c("icon", { attrs: { name: "icon-trash" } }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("BetSlip.selection.btn.clearall")) +
                                " "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.betsNo && _vm.currentBetSlipState < 2
                        ? _c("preference-switch", {
                            attrs: {
                              label: "showAcceptingChangesInfoRI",
                              id: "showAcceptingChangesInfo",
                              currentBetSlipState: _vm.currentBetSlipState
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-single-bet-slip",
            persistent: "",
            "hide-overlay": true,
            fullscreen: false,
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialogSingleBetslip.active,
            callback: function($$v) {
              _vm.$set(_vm.dialogSingleBetslip, "active", $$v)
            },
            expression: "dialogSingleBetslip.active"
          }
        },
        [
          _c("single-bet-slip", {
            attrs: { dialogSingleBetslip: _vm.dialogSingleBetslip }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-betslip-confirm",
            persistent: "",
            fullscreen: false
          },
          model: {
            value: _vm.dialogBetslipConfirm.active,
            callback: function($$v) {
              _vm.$set(_vm.dialogBetslipConfirm, "active", $$v)
            },
            expression: "dialogBetslipConfirm.active"
          }
        },
        [
          _c("betslip-confirm", {
            attrs: { dialogBetslipConfirm: _vm.dialogBetslipConfirm }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec7b971a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec7b971a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/Betslip.vue
// module id = null
// module chunks = 